var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M56.875 43.875C50.75 43.875 47.25 48.1 47.25 55.05V65.3H48.75V55.05C48.75 49.6 51.925 46.375 56.6 46.375C62.5 46.375 62.5 51.5 62.5 53.8V65.3H65V53.8C65 46.775 61.975 43.875 56.875 43.875ZM36.25 65.3H38.75V44.375H36.25V65.3ZM46.25 65.3H48.75V44.375H46.25V65.3ZM37.5 40C36.125 40 35 38.875 35 37.5C35 36.125 36.125 35 37.5 35C38.875 35 40 36.125 40 37.5C40 38.875 38.875 40 37.5 40ZM74.9 20H25.1C22.15 20 20 22.15 20 25.1V74.9C20 77.85 22.15 80 25.1 80H74.9C77.85 80 80 77.85 80 74.9V25.1C80 22.15 77.85 20 74.9 20ZM77.5 25.05V74.95C77.5 76.425 76.425 77.5 74.95 77.5H25.05C23.575 77.5 22.5 76.425 22.5 74.95V25.05C22.5 23.575 23.575 22.5 25.05 22.5H74.95C76.425 22.5 77.5 23.575 77.5 25.05Z","fill":"black"}));
}

Linkedin.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
